import * as React from 'react';
import { CustomButton, ButtonType } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { ManageReferralApi } from "../../../../api/ManageReferralApi";

interface IReferralWithdrawButton {
    canWithdrawReferral: boolean;
    referralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
}

export const ReferralWithdrawButton: React.FunctionComponent<IReferralWithdrawButton> = ({ canWithdrawReferral, changeSuccessMessage, changeErrorMessage, getReferral, referralId }) => {
    const auth = useAuth();
    const manageReferralApi = new ManageReferralApi(auth);
    const [isWithdrawingReferral, setIsWithdrawingReferral] = React.useState<boolean>(false);

    const withDrawReferral = () => {
        setIsWithdrawingReferral(true);
        manageReferralApi.withdrawReferral(referralId.toString(),
            () => {
                getReferral(referralId);
                changeSuccessMessage("Specialistremissen har återkallats");
            },
            (error) => {
                changeErrorMessage(error);
            },
            () => {
                setIsWithdrawingReferral(false);
            })
    }

    return (
        <>
            {
                canWithdrawReferral ?
                    <CustomButton buttonType={ButtonType.deleteAlt} buttonText="Återkalla specialistremiss" isLoading={isWithdrawingReferral} onClick={() => withDrawReferral()} />
                    : null
            }
        </>
    )
}